import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { IonicModule } from "@ionic/angular";
import { SharedModule } from "primeng/api";
import { ComponentsModule } from "../components/components.module";
import { GcLayoutModule } from "../components/v-layout/layout.module";
import { primeNgModule } from "../prime-ng-modules";
import { TranslateModule } from "@ngx-translate/core";
import { VComponentsModule } from "../modules/wrappers";
import { VTranslatePipe } from '../pipes/vtranslate.pipe';
import { VTranslateDirective } from '../components/vtranslate.directive';

export {
    CommonModule,
    FormsModule,
    FontAwesomeModule,
    IonicModule,
    SharedModule,
    ComponentsModule,
    primeNgModule,
    GcLayoutModule,
    TranslateModule,
    VComponentsModule,
    VTranslatePipe,
    VTranslateDirective
};

export const defaultModules = [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    SharedModule,
    ComponentsModule,
    primeNgModule,
    FontAwesomeModule,
    GcLayoutModule,
    TranslateModule,
    VComponentsModule,
    VTranslatePipe,
    VTranslateDirective
];